import React, { useState, useEffect } from "react";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";
import { Eye, EyeOff } from "lucide-react";

const BOReqModify = () => {
  useAuthRedirect();
    const {prNo, sNo} = useParams();
  const branch = localStorage.getItem("branch");
  const userId = localStorage.getItem("username");
  const [indentView, setIndentView] = useState({dept: "", remarks: "", hod: "", hm: "" });
  const [data, setData] = useState([]);
  const [formData, setFormData] = useState({})
  const [dept, setDept] = useState([]);
const navigate = useNavigate();
const [showLifeDetail, setShowLifeDetail] = useState(false);
const canEdit  = hasPermission("Branch office Requisition", "edit");

  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/bo_detailsHeader?prNo=${prNo}&branch=${branch}`);
        if (response.data && response.data.headerDetails?.length > 0) {
            const items = response.data.headerDetails;

            const storeReqHeader = {
                date: items[0].prHeader_date || "N/A",
                dept: items[0].prHeader_departmentCode || "N/A",
                branchCode: items[0].branchCode || "N/A",
                prHeader_hod: items[0].prHeader_hod || "N/A",
                prHeader_headMaterial: items[0].prHeader_headMaterial || "N/A",
                prHeader_remarks: items[0].prHeader_remarks || "N/A",
            };

            setIndentView(storeReqHeader);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchIndentDetails();
  }, [prNo, branch]); 

  const [loading, setLoading] = useState(true); // loading state


useEffect(() => {
  const fetchData = async () => {
    try {
      setLoading(true); // start loading
      const response = await axios.get(
        `https://rfs2.infraconsoft.net.in/api/bo_bottomDetails?prNo=${prNo}&branch=${branch}&sCode=${sNo}`
      );
      setData(response.data.bottomDetails || []);
    } catch (error) {
      console.error("Error fetching vehicles:", error);
      setData([]);
    } finally {
      setLoading(false); // stop loading
    }
  };

  fetchData();
}, [prNo, branch, sNo]);


useEffect(() => {
    const fetchDept = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/bo_dept?branch=${branch}`);
        setDept(response.data.dept || []);
      } catch (error) {
        console.error("Error fetching branches:", error);
      }
    };
    fetchDept();
  }, [branch]);


const handleRowChange = (index, field, value) => {
    setData((prevItems) =>
      prevItems.map((item, i) => (i === index ? { ...item, [field]: value } : item))
    );
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setIndentView((prev) => ({ ...prev, [name]: value }));
  };


 

    const handleSubmit = async (e) => {
  e.preventDefault();

  if (!indentView.prHeader_headMaterial.trim()) {
                Swal.fire({
                  icon: 'warning',
                  title: 'Empty Field',
                  text: 'Please Enter Head Meterial!',
                });
                return;
              }

              if (!indentView.prHeader_hod.trim()) {
                            Swal.fire({
                              icon: 'warning',
                              title: 'Empty Field',
                              text: 'Please Enter HOD!',
                            });
                            return;
                          }


  
  // ✅ 2. Validate Items
  if (!data || data.length === 0) {
    Swal.fire("Validation Error", "At least one item is required.", "warning");
    return;
  }

  for (let i = 0; i < data.length; i++) {
    const { prDetail_itemcode, prDetail_duedate, prDetail_quantity, prDetail_lifeTime } = data[i];

    if (!prDetail_itemcode || prDetail_itemcode.trim() === "") {
      Swal.fire("Validation Error", `Item code is missing in row ${i + 1}.`, "warning");
      return;
    }

    if (!prDetail_quantity || isNaN(prDetail_quantity) || prDetail_quantity <= 0) {
      Swal.fire("Validation Error", `Enter a valid quantity for item in row ${i + 1}.`, "warning");
      return;
    }

    if (!prDetail_duedate || prDetail_duedate.trim() === "") {
  Swal.fire("Validation Error", `Due date is required for item in row ${i + 1}.`, "warning");
  return;
}

if (isNaN(Date.parse(prDetail_duedate))) {
  Swal.fire("Validation Error", `Invalid due date format in row ${i + 1}.`, "warning");
  return;
}

// ✅ Ensure due date is today or future
const dueDate = new Date(prDetail_duedate);
const today = new Date();
today.setHours(0, 0, 0, 0); // reset time for accurate comparison

if (dueDate < today) {
  Swal.fire("Validation Error", `Due date cannot be in the past (row ${i + 1}).`, "warning");
  return;
}


    if ((isNaN(prDetail_lifeTime) || prDetail_lifeTime < 0)) {
      Swal.fire("Validation Error", `Lifetime must be a number in row ${i + 1}.`, "warning");
      return;
    }
  }

  try {
    const updatedData = {
      prNo: prNo,
      branch: branch,
      dept: indentView.dept,
      user: userId,
      remarks: indentView.prHeader_remarks,
      hm: indentView.prHeader_headMaterial,
      hod: indentView.prHeader_hod,
      items: data.map(({ prDetail_itemcode, prDetail_duedate, prDetail_quantity, prDetail_lifeTime }) => ({
        itemmaster_code: prDetail_itemcode,
        qty: prDetail_quantity,
        duedate: prDetail_duedate,
        lifetime: prDetail_lifeTime,
      }))
    };

    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const response = await axios.put("https://rfs2.infraconsoft.net.in/api/bo_update", updatedData);
    if (response.data.success) {
      Swal.fire("Success!", "Branch Store Req updated successfully!", "success");
      navigate('/inventory/mis_prview');
    } else {
      Swal.fire("Error", "Failed to update Branch Store Req", "error");
    }
  } catch (error) {
    console.error("Error updating Branch Store Req:", error);
    Swal.fire("Error", "Server error while updating", "error");
  }
};


if (!canEdit) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }



  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
            <div className="back-div">
                                  <h2 className="add-txt">Branch Office Purchase Requisition - Modify</h2>
                                  <Link to='/inventory/mis_prview'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                                  </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
          <div className="form-row">
              <div className="form-group">
                <label>Pr No :</label>
                <input type="text" name="indentNo" value={prNo} readOnly/>
              </div>
              <div className="form-group">
                <label>Date :</label>
                <input
  type="text"
  name="endhrs"
  value={indentView.date ? new Date(indentView.date).toISOString().split("T")[0] : ""}
 readOnly
/>

              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Type :</label>
                <input type="text" name="indentNo" value='Branch Office' readOnly/>
              </div>
              <div className="form-group">
                <label>Department :</label>
                <select name="dept" value={indentView.dept} onChange={handleInputChange} >
                  {dept.map((item, index) => (
                    <option key={index} value={item.departmentmaster_code}>
                      {item.departmentmaster_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>H.O.D :</label>
                <input type="text" value={indentView.prHeader_hod} name="prHeader_hod" onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>Head Meterial</label>
                <input type="text" value={indentView.prHeader_headMaterial} name="prHeader_headMaterial" onChange={handleInputChange}  />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Remarks :</label>
                <input type="text" value={indentView.prHeader_remarks} name="prHeader_remarks" onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label></label>
                <input type="hidden"  />
              </div>
            </div>


            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Supplier</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>Qty</th>
                    <th>Due Date</th>
                     {showLifeDetail && (
      <th style={{ textAlign: "center" }}>
        Life Detail
      </th>
    )}
     <th>
      <button
        type="button"
        onClick={() => setShowLifeDetail(!showLifeDetail)}
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
        }}
      >
        {showLifeDetail ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </th>
                  </tr>
                </thead>
               <tbody>
  {loading ? (
    <tr>
      <td colSpan="9" style={{ textAlign: "center", fontWeight: "bold" }}>
        Please wait, loading...
      </td>
    </tr>
  ) : data.length > 0 ? (
    data.map((item, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>
          {item.supplierMaster_code} - {item.supplierMaster_name}
        </td>
        <td>{item.prDetail_itemcode}</td>
        <td>{item.itemmaster_name}</td>
        <td>{item.itemMaster_purchaseUom}</td>
        <td>
          <input
            type="number"
            value={item.prDetail_quantity}
            onChange={(e) =>
              handleRowChange(index, "prDetail_quantity", e.target.value)
            }
          />
        </td>
        <td>
          <input
            type="date"
            value={
              item.prDetail_duedate
                ? new Date(item.prDetail_duedate).toISOString().split("T")[0]
                : ""
            }
            onChange={(e) =>
              handleRowChange(index, "prDetail_duedate", e.target.value)
            }
          />
        </td>
         {showLifeDetail && (
        <td>
          <input
            type="number"
            value={item.prDetail_lifeTime}
            onChange={(e) =>
              handleRowChange(index, "prDetail_lifeTime", e.target.value)
            }
          />
        </td>
                )}

      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="9" style={{ textAlign: "center" }}>
        No items
      </td>
    </tr>
  )}
</tbody>

              </table>
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Update
              </button>
            </div>
          </form>
        </div>
      </div>

    </div>
  );
};

export default BOReqModify;
